import { render, staticRenderFns } from "./SlidebarCustom.vue?vue&type=template&id=71b90a94&scoped=true&"
import script from "./SlidebarCustom.vue?vue&type=script&lang=js&"
export * from "./SlidebarCustom.vue?vue&type=script&lang=js&"
import style0 from "./SlidebarCustom.vue?vue&type=style&index=0&id=71b90a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b90a94",
  null
  
)

export default component.exports